<template>
    <div class="text-xs-center">
        <v-dialog v-model="show" width="500" scrollable>
            <v-card>
                <v-card-title>{{title}}</v-card-title>
                <v-card-text>
                    <template v-for="(error, index) in errors">
                        <material-notification v-if="error.classification == 1" :key="index" class="mb-3" color="info">
                            {{error.userMessage}}
                        </material-notification>   

                        <material-notification v-if="error.classification == 2" :key="index" class="mb-3" color="warning">
                            {{error.userMessage}}
                        </material-notification>   

                        <material-notification v-if="error.classification == 3" :key="index" class="mb-3" color="error">
                            {{error.userMessage}}
                        </material-notification>     
                    </template>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="close">
                        {{closeText}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters , mapMutations } from 'vuex'

export default {
    computed:{
        show(){
            return this.$store.state.app.errorMessageBox.show;
        },
        title(){
            return this.$store.state.app.errorMessageBox.title;
        },        
        errors(){
            return this.$store.state.app.errorMessageBox.error;
        },
        closeText(){
            return this.$t("Common.close");
        }                   
    },
    methods:{      
        ...mapMutations("app", ["setErrors"]),   
        close(){
            let errorMessageBox = this.$store.state.app.errorMessageBox;
            errorMessageBox.show = false;
            this.setErrors(errorMessageBox); 
        }
    }
}
</script>